import templateUrl from './serious-risk-by-year.html';

export default {
  templateUrl,
  controller: class SeriousRiskByYearComponent {
    constructor($scope, LoadingService, SeriousRiskByYearService, ToastService) {
      'ngInject';

      Object.assign(this, {
        $scope,
        LoadingService,
        SeriousRiskByYearService,
        ToastService
      });
    }

    $onInit() {
      this.chartConfig = {
        chart: {
          zoomType: 'xy'
        },
        title: {
          text: 'Serious AE Report Rate Per Million Administrations Sold'
        },
        subtitle: {
          text: 'NASC Adverse Event Reporting System'
        },
        xAxis: {
          type: 'datetime',
          title: {
            style: {
              fontSize: '14px'
            }
          },
          labels: {
            style: {
              fontSize: '14px'
            }
          },
          tickInterval: 12 * 30 * 24 * 3600 * 1000 // for quarterly 3 * 30 * 24 * 3600 * 1000
        },
        yAxis: [{
          title: {
            text: 'Risk (case per mil)',
            style: {
              color: window.Highcharts.getOptions().colors[1],
              fontSize: '14px'
            }
          },
          labels: {
            format: '{value}',
            style: {
              color: window.Highcharts.getOptions().colors[1],
              fontSize: '14px'
            }
          }
        }, {
          title: {
            text: 'Administrations (mil)',
            style: {
              color: window.Highcharts.getOptions().colors[0],
              fontSize: '14px'
            }
          },
          labels: {
            format: '{value}',
            style: {
              color: window.Highcharts.getOptions().colors[0],
              fontSize: '14px'
            }
          },
          opposite: true
        }],
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:,.2f}</b></td></tr>',
          footerFormat: '</table>',
          split: true,
          useHTML: true
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          x: 100,
          verticalAlign: 'top',
          y: 20,
          floating: true,
          itemWidth: 180,
          itemDistance: 0,
          itemStyle: {
            fontSize: '14px'
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: false
            }
          },
          area: {
            fillOpacity: 0.2,
            lineColor: '#666666',
            lineWidth: 1,
            marker: {
              enabled: false
            }
          }
        }
      };
    }

    generateReport({ params }) {
      this.LoadingService.start();
      this.SeriousRiskByYearService.getReport(params)
        .then((series) => {
          this.chartConfig.series = series;
        }).catch((error) => {
          this.ToastService.showError(error);
          this.$scope.$apply();
        }).finally(() => this.LoadingService.stop());
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/reports/serious-risk-by-year/serious-risk-by-year.component.js